import { c as _c } from "react/compiler-runtime";
import { Box, Button, Card, Heading, Stack, Image, Text, Spacer, VStack, AspectRatio } from '@chakra-ui/react';
import { PaywalledAction } from '@src/components/sco/PaywalledAction';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { Benefit } from '@src/graphql-types';
type PartnerCardProps = {
  benefit: Benefit;
  keywords?: string;
};
export const PartnerCard = props => {
  const $ = _c(34);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      transform: "scale(1.005)"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      bgColor: "colorPalette.subtle"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `/perks/partners/${props.benefit.slug}`;
  const t3 = props.benefit.cardImage?.url;
  let t4;
  if ($[2] !== t3) {
    t4 = <Image borderRadius="lg" boxShadow="md" src={t3} width="full" />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = <AspectRatio asChild={true} ratio={1.7777777777777777}><NextLink href={t2}>{t4}</NextLink></AspectRatio>;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `/perks/partners/${props.benefit.slug}`;
  let t7;
  if ($[7] !== props.benefit.name || $[8] !== t6) {
    t7 = <Heading size="xl"><NextLink href={t6}>{props.benefit.name}</NextLink></Heading>;
    $[7] = props.benefit.name;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== props.benefit.teaser) {
    t8 = <Text fontSize="md">{props.benefit.teaser}</Text>;
    $[10] = props.benefit.teaser;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <VStack align="flex-start" justify="stretch">{t7}{t8}</VStack>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Spacer />;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Text color="colorPalette.fg/50" textStyle="label">Benefit</Text>;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== props.benefit.valueDescription) {
    t12 = <VStack align="flex-start" bgGradient="to-b" borderTopRadius="xl" gradientFrom="colorPalette.subtle" gradientTo="transparent" padding={6}>{t11}<Text fontSize="lg" fontWeight="semibold">{props.benefit.valueDescription}</Text></VStack>;
    $[17] = props.benefit.valueDescription;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Spacer />;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== props.benefit.title) {
    t14 = props.benefit.title ? {
      partnerName: props.benefit.title
    } : undefined;
    $[20] = props.benefit.title;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  const t15 = `/perks/partners/${props.benefit.slug}`;
  let t16;
  if ($[22] !== t15) {
    t16 = <Button asChild={true} size="lg" variant="solid"><NextLink href={t15}>View Details</NextLink></Button>;
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t14 || $[25] !== t16) {
    t17 = <PaywalledAction contentPermission="canAccessPremiumBenefits" tokens={t14} variant="button-only">{t16}</PaywalledAction>;
    $[24] = t14;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t12 || $[28] !== t17 || $[29] !== t9) {
    t18 = <Stack direction="column" gap="3" height="full" mt="6">{t9}{t10}{t12}{t13}{t17}</Stack>;
    $[27] = t12;
    $[28] = t17;
    $[29] = t9;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t18 || $[32] !== t5) {
    t19 = <Box><Card.Root _hover={t0} borderRadius="xl" boxShadow="lg" height="full" maxW="full" overflow="hidden" transition="all 0.5s ease"><Card.Body _hover={t1} bgColor="colorPalette.muted" display="flex" flexDirection="column" transition="all 0.5s ease">{t5}{t18}</Card.Body></Card.Root></Box>;
    $[31] = t18;
    $[32] = t5;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  return t19;
};